import React from 'react';

const BdUserPage = () => {
  return (
    <div>
      <h1>Acceso permitido</h1>
      <h4>Saludos, ya puedes insertar y modificar registros.
      Las propuestas serán enviadas al equipo de revisión para su evaluación.</h4>
    </div>
  );
};

export default BdUserPage;